const creationModeEnum = {
  automatic: 'Automatic',
  manual: 'Manual',
};

export default creationModeEnum;
